/* src/app/components/doc-viewer-new/doc-viewer-context-panel/doc-viewer-context-panel.component.scss */
::ng-deep .doc-viewer-menu .reviewed-documents-title-header {
  margin-right: 12px;
}
::ng-deep .doc-viewer-menu .context-panel-icon {
  font-size: 16px;
  color: rgb(36, 62, 144);
  width: 30px;
}
#context-panel-main {
  position: relative;
  overflow: hidden;
  width: 310px;
  min-width: 65px;
  background: #fff;
  height: 100%;
  box-shadow: 0 3px 3px rgba(0, 0, 0, 0.25);
}
:host-context(.dark-theme) #context-panel-main {
  background: #303030;
  border-right: none;
  box-shadow: 0 3px 3px rgba(20, 20, 20, 0.82);
}
#context-panel-toggle {
  background: rgb(36, 62, 144);
  cursor: pointer;
  position: absolute;
  bottom: 0;
  width: 100%;
  height: 50px;
  border-top: 1px solid #b8b8b8;
  display: flex;
  align-items: center;
  justify-content: flex-end;
}
:host-context(.dark-theme) #context-panel-toggle {
  background: #303030;
  border-top: 1px solid rgb(88, 88, 88);
}
.resume-footer {
  height: 1px;
  width: 100%;
  background: #F2F2F2;
  margin: 15px 0 40px;
}
:host-context(.dark-theme) .resume-footer {
  background: rgb(88, 88, 88);
}
.context-panel-top-container {
  background: #f5f5f5;
  border-bottom: 1px solid #e2e2e2;
}
.context-panel-top-container .context-panel-title-container {
  color: #000;
}
.context-panel-top-container .context-panel-icon {
  font-size: 16px;
  color: rgb(36, 62, 144);
  width: 30px;
}
.context-panel-top-container .context-panel-expand-icon {
  display: flex;
  justify-content: center;
  align-items: center;
  border-radius: 50%;
  height: 20px;
  width: 20px !important;
  opacity: 0.5;
  transition: opacity 550ms ease-out, transform 500ms ease-out;
}
.context-panel-top-container:hover .context-panel-expand-icon {
  opacity: 1;
  transform: scale(1.1);
}
:host-context(.dark-theme) .context-panel-top-container {
  background: black;
  border-bottom: initial;
}
:host-context(.dark-theme) .context-panel-top-container .context-panel-title-container {
  color: white;
}
:host-context(.dark-theme) .context-panel-top-container .context-panel-icon {
  color: rgb(255, 193, 7);
}
:host-context(.dark-theme) .reviewed-documents-title-header {
  color: rgb(255, 193, 7);
}
.reviewed-docs-container {
  height: 1px;
  width: 100%;
  background: #F2F2F2;
  margin: 15px 0 0;
}
:host-context(.dark-theme) .reviewed-docs-container {
  background: rgb(88, 88, 88);
}
.reviewed-docs {
  display: flex;
  flex-direction: column;
  padding: 10px 20px;
  font-size: 14px;
  color: black;
  cursor: pointer;
}
:host-context(.dark-theme) .reviewed-docs {
  color: white;
}
.reviewed-docs-content {
  display: flex;
  flex-direction: row;
  align-items: center;
  overflow: hidden;
  justify-content: space-between;
}
.reviewed-docs-node-container {
  display: flex;
  overflow: hidden;
}
.reviewed-docs-node {
  margin-right: 12px;
  color: rgb(36, 62, 144);
}
:host-context(.dark-theme) .reviewed-docs-node {
  color: #9fa8da;
}
:host-context(.dark-theme) .reviewed .reviewed-docs-node {
  color: white;
}
.reviewed .reviewed-docs-node {
  color: grey;
}
.attention .reviewed-docs-node {
  color: rgb(36, 62, 144);
}
:host-context(.dark-theme) .attention .reviewed-docs-node {
  color: #9fa8da;
}
.validation-notification {
  margin-left: 32px;
  color: rgb(63, 81, 181);
}
:host-context(.dark-theme) .validation-notification {
  color: rgb(255, 193, 7);
}
.toggle-arrow {
  font-size: 16px;
  margin-right: 20px;
  color: #fff;
}
:host-context(.dark-theme) .toggle-arrow {
  color: rgb(255, 193, 7);
}
.active {
  border-left: 4px solid rgb(63, 81, 181);
  background: rgba(57, 73, 171, 0.08);
  padding: 10px 18px;
}
:host-context(.dark-theme) .active {
  border-left: 4px solid rgb(89, 114, 255);
  background: rgba(255, 193, 7, 0.06);
}
.child {
  padding: 10px 20px 10px 45px !important;
}
.reviewed {
  opacity: 0.5;
}
.lex-doc-node {
  font-size: 14px;
}
.attention {
  opacity: 1;
}
/*# sourceMappingURL=doc-viewer-context-panel.component.css.map */
